<style>
    .page-my-address .van-address-edit__buttons {
        padding: .3rem .3rem 0;
    }

    .page-my-address .address__title {
        padding: .3rem 15px .1rem;
        color: #666666;
        font-size: 12px;
    }

    .page-my-address .address__desc {
        padding: .2rem .3rem .2rem;
        color: #666666;
        font-size: .24rem;
    }

    .page-my-address .van-cell-group.van-hairline--top-bottom::after {
        border-width: 1px 0 0;
    }

</style>
<template>
    <div class="page page-my-address">
        <div class="page__inner">
            <txt-no-data v-if="!isValidUser" message="您未登录，请先登录" />
            <txt-loading v-else-if="!myDetail" />
            <div v-else-if="myAddress" class="myAddress">
                <van-cell-group>
                <van-cell title="收货人" :value="myAddress.name" />
                <van-cell title="手机号" :value="myAddress.mobile" />
                <van-cell title="收地址" value="" :label="myAddress.address" />
                </van-cell-group>
            </div>
            <div v-else class="myAddress">
                <div class="address__title">填写领奖信息</div>
                <van-address-edit :area-list="areaList" @save="onSave" @change-area="onChangeArea" @change-detail="onChangeDetail"
                    save-button-text="确认提交">

                    <div class="address__desc">以上个人信息仅用于邮寄奖品使用，如有问题请联系客服:<br><a href="tel:4006776878">400-677-6878</a></div>
                </van-address-edit>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex'
    import {
        map
    } from '../../../common/utils'
    import {
        provinceMap,
        cityMap,
        countyMap
    } from '../../../common/area'

    export default {
        data() {
            return {
                areaList: {
                    province_list: provinceMap,
                    city_list: cityMap,
                    county_list: countyMap
                },
                area: '',
                street: ''
            }
        },
        computed: {
            ...mapState(['myDetail', 'myAddress']),
            ...mapGetters(['subCityList', 'isValidUser']),
            provinces() {
                return this.subCityList(0)
            }
        },
        methods: {
            ...mapActions(['loadDistricts', 'addAddress']),
            async onSave(content) {
                const {
                    province,
                    city,
                    county,
                    addressDetail,
                    name,
                    tel
                } = content
                const address = [province, city === province ? '' : city, county, addressDetail].join('')
                // console.log(address);
                await this.addAddress({
                    name,
                    mobile: tel,
                    address
                })
                // this.address = address
                this.$toast('领奖人信息提交成功');
                this.$router.push("/match/my/awards")
            },
            onChangeArea(val) {
                // console.log(val);
                this.area = map(val, (o, i) => {
                    const name = o.name
                    return i > 0 && name === val[i - 1].name ? '' : name
                }).join('')
            },
            onChangeDetail(val) {
                if (val) {
                    this.street = val;
                } else {
                    this.street = '';
                }
            }
        },
        async created() {
            // 加载决赛记录
            // this.loadDistricts({})
        }
    };

</script>
